import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getReMobilization = createAsyncThunk("api/remobilization", async (token) => {
  try {
    const response = await nodeinstance.get("/demobilization/idleCandidates?status=REMOBILIZE", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const ReMobilizationDataSlice = createSlice({
  name: "remobilization",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReMobilization.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getReMobilization.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getReMobilization.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getReMobilization };
export default ReMobilizationDataSlice.reducer;
